import { Component, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/core/services/auth.service';


@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss']
})
export class TrackingComponent {

  showOverlay:boolean = false
  fullData:any
  timeline = []
  limitedTimeline = []


 constructor(
    private authService:AuthenticationService,
    private router: Router,
    private toastr: ToastrService,
        private modalService: NgbModal,
    
  ){

  }


  ngOnInit(): void {
    this.tracking()
  }

tracking() {
  this.showOverlay = true
  let data = {
    awb: localStorage.getItem('tracking_awb')
  };

  this.authService.tracking(data).subscribe(
    (res: any) => {
      let mes = JSON.parse(res);
      res = mes;

      if (mes.statusCode === 202) {
        this.fullData = res.Data;
        this.showOverlay = false;
        this.toastr.success(mes.success);
        console.log(res.Data)
        if (res.Data) {
  this.fullData = res.Data;
  const data = res.Data?.[0];

if (data) {
  this.timeline = data.scan_details.map((item, index) => {
    const scan = item?.ScanDetail || {};
    
    let formattedDate = '';
    if (scan.ScanDateTime) {
      const date = new Date(scan.ScanDateTime);
      formattedDate = date.toLocaleString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    }

    return {
      status: scan.Scan || '',
      date: formattedDate || undefined,
      subtext: scan.Instructions || undefined,
      icon: (index + 1).toString(),
      completed: true
    };
  });

  this.limitedTimeline = this.timeline.slice(0, 4);

  console.log(this.timeline);
} else {
  console.warn('scan_details missing or not an array');
  this.timeline = [];
}




  console.log(this.timeline, 'timeline');
  this.showOverlay = false
} else {
  console.warn('scan_details missing or not an array');
  this.timeline = [];
}



        console.log(this.timeline, 'timeline');
        this.showOverlay = false
      
      } 
      else if(mes.statusCode === 204){
        this.toastr.error(mes.error, '');
        this.timeline = []
         this.limitedTimeline = []
         this.showOverlay = false
        
      }
      else {
        if (
          mes.error === 'Token has expired' ||
          mes.error === 'Invalid token' ||
          mes.error === 'Token is required'
        ) {
          this.showOverlay = false;
          this.router.navigate(['/auth/login']);
        } else {
          this.toastr.error(mes.error, '');
          this.showOverlay = false;
        }
      }
    },
    (error) => {
      this.showOverlay = false;
      if (error.status === 502) {
        this.toastr.error('502 Bad Gateway', 'An error occurred');
      } else {
        this.toastr.error('An error occurred while communicating with the server.', 'Please try again after some time');
      }
    }
  );
}


open(content: TemplateRef<any>) {
  this.modalService.open(content, { centered: true,size: 'm'});

}


//  get limitedTimeline() {
//     return this.timeline.slice(0, 4);
//   }




 





}
